export default {
  brand: "USFansLink",
  nav: {
    spreadsheets: "Hojas de cálculo",
    products: "Productos",
    sellers: "Vendedores",
    reviews: "Reseñas",
    shipping: "Envío",
    coupons: "Cupones",
    guides: "Guías",
    safety: "Seguridad",
    buyNow: "Comprar ahora",
    home: "Inicio",
    shoppingGuide: "Guía de compras",
    categories: "Categorías",
    chooseLanguage: "Idioma",
  },
  hero: {
    badge: "Recurso independiente • Guías actualizadas • Soporte multilingüe",
    title: "Hoja de cálculo de USFans – Encuentra productos, vendedores y guías de compra",
    subtitle:
      "Explora la hoja de cálculo de USFans para descubrir listas de productos útiles, recursos de vendedores, guías de compra, información de envío, consejos de control de calidad y los últimos recursos de USFans, todo organizado en un solo lugar fácil de usar.",
    ctaPrimary: "Hoja de cálculo de USFans",
    ctaSecondary: "Comprar ahora",
    hint: "Abre la tienda oficial de USFans en una pestaña nueva",
  },
  categories: {
    title: "Explora productos por categoría",
    subtitle:
      "Salta directo a la categoría que necesitas. Cada enlace abre la tienda de USFans para que puedas seguir comprando sin complicaciones.",
    dropdownLabel: "Elige una categoría",
    dropdownPlaceholder: "Selecciona una categoría…",
    openLabel: "Ver categoría",
    shoes: "Zapatos",
    hoodies: "Sudaderas y suéteres",
    tshirts: "Camisetas",
    jackets: "Chaquetas",
    pants: "Pantalones y shorts",
    headwear: "Gorras y sombreros",
    sets: "Conjuntos",
    underwear: "Ropa interior y calzoncillos",
    jerseys: "Camisetas deportivas",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    other: "Otros",
  },
  resources: {
    title: "Todo lo que necesitas para investigar productos de USFans",
    subtitle:
      "Buscar productos, vendedores o información útil de USFans puede llevar mucho tiempo. USFansLink organiza los recursos importantes en hojas de cálculo, guías, comparaciones y tutoriales claros para que investigues productos de forma más eficiente y tomes mejores decisiones.",
    cards: {
      spreadsheet: { title: "Hoja de cálculo de USFans", desc: "Información organizada de productos y vendedores en una vista clara y filtrable." },
      productLists: { title: "Listas de productos", desc: "Listas seleccionadas que te ayudan a comparar artículos entre categorías rápidamente." },
      sellerGuides: { title: "Guías de vendedores", desc: "Consejos prácticos para investigar vendedores y leer su historial." },
      shippingGuides: { title: "Guías de envío", desc: "Explicaciones claras de opciones de envío, costos y tiempos de entrega." },
      qcResources: { title: "Recursos de control de calidad", desc: "Listas de verificación y consejos de fotos para revisar la calidad antes de comprar." },
      safetyGuides: { title: "Guías de seguridad", desc: "Seguridad de la cuenta, enlaces sospechosos y conciencia de pago en un solo lugar." },
    },
  },
  spreadsheet: {
    title: "Hoja de cálculo de USFans",
    text: "Empieza con la hoja de cálculo de USFans para explorar información organizada de productos y vendedores. Usa filtros, categorías y guías de apoyo para acotar lo que buscas antes de tomar una decisión.",
    cta: "Abrir guía de la hoja de cálculo",
  },
  popular: {
    title: "Recursos populares de USFans",
    subtitle: "Acceso rápido a los temas que más buscan los compradores.",
    comingSoon: "Guía próximamente",
    cards: {
      review: { title: "Reseña de USFans", desc: "Una mirada independiente a las funciones, el flujo de compra y la experiencia general." },
      shippingCost: { title: "Costo de envío de USFans", desc: "Cómo pueden variar las opciones y costos de envío según el destino." },
      coupon: { title: "Cupón de USFans", desc: "Dónde buscar ofertas actuales y cómo aplicarlas." },
      discountCode: { title: "Código de descuento de USFans", desc: "Consejos para encontrar ofertas disponibles antes del pago." },
      warehouse: { title: "Almacén de USFans", desc: "Cómo afectan el almacenamiento y los procesos de almacén a la entrega." },
      legit: { title: "¿Es USFans legítimo?", desc: "Una guía equilibrada sobre confianza y seguridad." },
    },
  },
  confidence: {
    title: "Investiga productos con más confianza",
    text: "Usa información de productos, investigación de vendedores, recursos de control de calidad y guías de envío juntos, en lugar de depender de una sola fuente. Nuestro objetivo es hacer el proceso de investigación más fácil de entender.",
  },
  shipping: {
    title: "Guías de envío, almacén y entrega de USFans",
    text: "Descubre cómo las opciones de envío, los procesos de almacén y las consideraciones de entrega pueden afectar tu experiencia de compra.",
    cta: "Explorar guías de envío",
  },
  review: {
    title: "Reseña y guía de experiencia de USFans",
    text: "¿Buscas una reseña de USFans? Explora nuestras guías independientes sobre funciones de la plataforma, flujo de compra, envío, información del almacén, consideraciones de seguridad y preguntas frecuentes.",
    cta: "Leer reseña de USFans",
  },
  safety: {
    title: "Centro de seguridad de USFans",
    text: "Antes de usar cualquier plataforma de compras o recurso de vendedores, comprende los posibles riesgos. Nuestro Centro de Seguridad cubre seguridad de la cuenta, investigación de vendedores, controles de calidad, conciencia de pago, consideraciones de envío y enlaces sospechosos.",
    cta: "Visitar Centro de Seguridad",
  },
  guides: {
    title: "Últimas guías de la hoja de cálculo de USFans",
    subtitle: "Guías nuevas y originales para ayudarte a investigar mejor.",
    readMore: "Leer guía",
    article: {
      title: "¿Qué es la hoja de cálculo de USFans? Guía completa",
      excerpt:
        "Aprende qué es la hoja de cálculo de USFans, qué contiene, cómo usarla para encontrar productos y vendedores, y qué saber sobre envío, control de calidad y seguridad antes de comprar.",
      tag: "Guía para principiantes",
    },
    moreSoon: "Pronto llegarán más guías: envío, cupones, almacén y reseñas detalladas.",
  },
  faq: {
    title: "Preguntas frecuentes",
    subtitle: "Respuestas rápidas a las preguntas más comunes sobre la hoja de cálculo de USFans.",
    questions: {
      q1: "¿Qué es una hoja de cálculo de USFans?",
      a1: "Es un recurso organizado que reúne listas de productos, información de vendedores y categorías en una sola vista, para que puedas comparar opciones sin saltar entre muchas páginas.",
      q2: "¿Cómo uso una hoja de cálculo de USFans?",
      a2: "Elige una categoría y luego filtra u ordena las columnas que te interesan, como precio o envío. Una vez que acotes tus opciones, sigue los enlaces de productos para continuar en la tienda principal.",
      q3: "¿Es USFans legítimo?",
      a3: "USFans es una plataforma de compras utilizada por muchos compradores. Como en cualquier tienda, investiga a los vendedores, revisa las fotos de control de calidad y ten cuidado con solicitudes de pago inusuales antes de comprar.",
      q4: "¿Cuánto cuesta el envío de USFans?",
      a4: "Los costos de envío varían según el vendedor, el destino y el método. Confirma siempre el costo final en la columna de envío o en el pago antes de realizar el pedido.",
      q5: "¿USFans tiene cupones?",
      a5: "Las ofertas y los códigos de descuento van y vienen. Revisa los recursos más recientes de cupones y códigos antes de pagar, ya que un código puede funcionar solo para ciertas categorías o pedidos mínimos.",
      q6: "¿Dónde está el almacén de USFans?",
      a6: "Las ubicaciones y procesos de almacén pueden variar. Revisa las notas de almacén del vendedor al que le compras para entender los tiempos de almacenamiento y entrega.",
      q7: "¿Cómo puedo investigar a los vendedores de USFans?",
      a7: "Revisa el historial del vendedor, lee reseñas, mira las fotos de control de calidad cuando estén disponibles y verifica los detalles de envío y pago antes de decidir la compra.",
    },
  },
  finalCta: {
    title: "Comienza tu investigación de USFans",
    text: "Explora la hoja de cálculo de USFans, compara recursos útiles y continúa tu investigación de productos con nuestras últimas guías.",
    cta: "Explorar la hoja de cálculo de USFans",
  },
  notFound: {
    title: "Esta página aún no se ha generado",
    subtitle: "Cuéntanos más sobre esta página y la generaremos para ti.",
    backHome: "Volver al inicio",
  },
  footer: {
    about: "Acerca de",
    contact: "Contacto",
    privacy: "Política de privacidad",
    terms: "Términos",
    editorial: "Política editorial",
    updates: "Actualizaciones",
    disclaimer:
      "USFansLink es un recurso informativo independiente y no está afiliado ni respaldado por USFans, salvo que se indique explícitamente.",
    rights: "Todos los derechos reservados.",
  },
};